/** Line icons for the modules grid. 1.5px stroke, 40×40 frame, gold. */

type IconProps = { size?: number; className?: string };

const base = (size: number, className?: string) => ({
  width: size,
  height: size,
  viewBox: '0 0 40 40',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  className,
});

export function CrossIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <line x1="20" y1="6" x2="20" y2="34" />
      <line x1="11" y1="14" x2="29" y2="14" />
      <line x1="13" y1="22" x2="27" y2="28" />
    </svg>
  );
}
export function BookIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <path d="M6 8 H18 a3 3 0 0 1 3 3 V32 a3 3 0 0 0 -3 -3 H6 Z" />
      <path d="M34 8 H22 a3 3 0 0 0 -3 3 V32 a3 3 0 0 1 3 -3 H34 Z" />
    </svg>
  );
}
export function RopeIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <circle cx="20" cy="20" r="11" />
      {Array.from({ length: 8 }).map((_, i) => {
        const a = (i / 8) * Math.PI * 2;
        const x = 20 + Math.cos(a) * 11;
        const y = 20 + Math.sin(a) * 11;
        return <circle key={i} cx={x} cy={y} r="1.4" fill="currentColor" />;
      })}
    </svg>
  );
}
export function WheatIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <line x1="20" y1="34" x2="20" y2="10" />
      <path d="M20 26 Q14 24 14 20 Q14 18 20 18" />
      <path d="M20 26 Q26 24 26 20 Q26 18 20 18" />
      <path d="M20 18 Q14 16 14 12 Q14 10 20 10" />
      <path d="M20 18 Q26 16 26 12 Q26 10 20 10" />
    </svg>
  );
}
export function ScrollIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <path d="M10 8 H26 a4 4 0 0 1 4 4 V28 a4 4 0 0 1 -4 4 H10" />
      <path d="M10 8 a4 4 0 0 0 -4 4 V28 a4 4 0 0 0 4 4" />
      <line x1="14" y1="16" x2="24" y2="16" />
      <line x1="14" y1="22" x2="24" y2="22" />
    </svg>
  );
}
export function CenserIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <line x1="20" y1="4" x2="20" y2="14" />
      <path d="M12 14 H28" />
      <path d="M14 14 Q14 28 20 32 Q26 28 26 14" />
      <path d="M16 22 Q20 24 24 22" />
    </svg>
  );
}
export function QuillIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <path d="M30 6 Q14 14 8 32 L14 26 Q22 24 30 6 Z" />
      <line x1="8" y1="32" x2="14" y2="26" />
    </svg>
  );
}
export function ProfileIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <circle cx="20" cy="15" r="6" />
      <path d="M8 32 Q8 22 20 22 Q32 22 32 32" />
    </svg>
  );
}
export function BellIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <path d="M10 26 Q10 14 20 14 Q30 14 30 26 L32 28 H8 Z" />
      <line x1="20" y1="10" x2="20" y2="14" />
      <path d="M17 30 Q17 33 20 33 Q23 33 23 30" />
    </svg>
  );
}
export function ChurchIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <line x1="20" y1="4" x2="20" y2="10" />
      <line x1="17" y1="7" x2="23" y2="7" />
      <path d="M20 10 L10 18 V32 H30 V18 Z" />
      <path d="M16 32 V24 a4 4 0 0 1 8 0 V32" />
    </svg>
  );
}
export function CandleIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <path d="M20 6 Q22 9 22 11 Q22 13 20 13 Q18 13 18 11 Q18 9 20 6 Z" />
      <line x1="20" y1="13" x2="20" y2="16" />
      <rect x="15" y="16" width="10" height="18" />
    </svg>
  );
}
export function KeyIcon({ size = 40, className }: IconProps) {
  return (
    <svg {...base(size, className)}>
      <circle cx="13" cy="20" r="6" />
      <line x1="19" y1="20" x2="34" y2="20" />
      <line x1="28" y1="20" x2="28" y2="26" />
      <line x1="32" y1="20" x2="32" y2="24" />
    </svg>
  );
}
export function ChevronDown({ size = 18, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d="M4 7 L9 12 L14 7" />
    </svg>
  );
}
export function ArrowRight({ size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <line x1="2" y1="8" x2="13" y2="8" />
      <path d="M9 4 L13 8 L9 12" />
    </svg>
  );
}
export function AppleIcon({ size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path d="M11.4 8.5c0-1.4 1.1-2.1 1.2-2.1-0.7-0.9-1.7-1-2.1-1-0.9-0.1-1.8 0.5-2.2 0.5s-1.2-0.5-1.9-0.5c-1 0-1.9 0.6-2.4 1.5-1 1.7-0.3 4.3 0.7 5.7 0.5 0.7 1 1.4 1.8 1.4s1-0.5 1.9-0.5 1.1 0.5 1.9 0.5 1.3-0.7 1.7-1.4c0.5-0.8 0.7-1.6 0.7-1.6S11.4 9.9 11.4 8.5zM10 4.3c0.4-0.5 0.7-1.2 0.6-1.9-0.6 0.1-1.3 0.4-1.7 0.9-0.4 0.4-0.7 1.1-0.6 1.8C9 5.2 9.6 4.8 10 4.3z" />
    </svg>
  );
}
export function PlayIcon({ size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path d="M3 2 L13 8 L3 14 Z" />
    </svg>
  );
}
export function SunIcon({ size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      aria-hidden
      className={className}
    >
      <circle cx="8" cy="8" r="3" />
      <line x1="8" y1="1.5" x2="8" y2="3" />
      <line x1="8" y1="13" x2="8" y2="14.5" />
      <line x1="1.5" y1="8" x2="3" y2="8" />
      <line x1="13" y1="8" x2="14.5" y2="8" />
      <line x1="3.3" y1="3.3" x2="4.3" y2="4.3" />
      <line x1="11.7" y1="11.7" x2="12.7" y2="12.7" />
      <line x1="3.3" y1="12.7" x2="4.3" y2="11.7" />
      <line x1="11.7" y1="4.3" x2="12.7" y2="3.3" />
    </svg>
  );
}
export function MoonIcon({ size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d="M13 9.5 A6 6 0 1 1 6.5 3 A4.5 4.5 0 0 0 13 9.5 Z" />
    </svg>
  );
}
